import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, DatePicker } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const ApproveContract = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const onFinish = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        approvedOnDate: values.approvedOnDate?.format("YYYY-MM-DD"),
      };
      // await BOM.SendReq(apiConfig.approveContract, { id, ...payload });
      console.log("ApproveContract payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Contract approved successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to approve contract.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.manageTBContract}>
      <TopContent pageTitle={labelConfig.tbContract} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
              Approve Contract
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Approved On Date{" "}
                        <Tooltip title="The date on which this contract is approved.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="approvedOnDate"
                    rules={[
                      { required: true, message: "Approval date is required" },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44 }}
                      format="YYYY-MM-DD"
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #BA24D5",
                      background: "#BA24D5",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Approve Contract
                  </button>
                </Col>
              </Row>
              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({ rightBtn: state.RightSideBtn });
export default connect(mapStateToProps, { rightAction })(ApproveContract);
